/**
 * Converts kebab-case string to camelCase.
 * @example kebabToCamel("home-care-service") // "homeCareService"
 * @example kebabToCamel("office") // "office"
 */
export const kebabToCamel = (str: string): string =>
  str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
